export default __webpack_public_path__ + "static/media/A90DBBF2-00.26586efa.png";